import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extract a user-friendly error message from an API error.
 * Falls back to a generic message when the error structure is unexpected.
 */
export function getErrorMessage(error: unknown, fallback: string): string {
  if (
    error != null &&
    typeof error === 'object' &&
    'body' in error
  ) {
    const body = (error as { body: unknown }).body;
    if (body != null && typeof body === 'object' && 'error' in body) {
      const errObj = (body as { error: unknown }).error;
      // Handle { error: { message: string } }
      if (errObj != null && typeof errObj === 'object' && 'message' in errObj) {
        const msg = (errObj as { message: unknown }).message;
        if (typeof msg === 'string' && msg.length > 0) return msg;
      }
      // Handle { error: string } (e.g. interferencia service responses)
      if (typeof errObj === 'string' && errObj.length > 0) return errObj;
    }
    // Some error responses use { message: string } directly
    if (body != null && typeof body === 'object' && 'message' in body) {
      const msg = (body as { message: unknown }).message;
      if (typeof msg === 'string' && msg.length > 0) return msg;
    }
  }
  // Plain Error (not an apiClient error with .body) — e.g. a thrown S3 upload
  // failure or any other non-API error. Previously fell straight to fallback,
  // masking the real message.
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
